import { isEmpty } from 'lodash'

import axiosInstance from 'api/axiosInstance'

interface IMostPlayed {
  video_id: string
  unique_id: string
  most_played:any
}

export const setMostPlayed = async ({
    video_id,
    unique_id,
    most_played
}: IMostPlayed) => {
    const { data } = await axiosInstance({
        method: 'POST',
        url: `/api/user/replays/${video_id}`,
        data: {
            unique_id,
            most_played
        }
    })

    return data
}
